import styled from "styled-components";
import { Label } from "./Label.styled";

export const RadioInputsWrapper = styled.div`
  ${Label}:not(:first-child) {
    margin-top: 20px;
  }
`;
